import { render, staticRenderFns } from "./cardManagement.vue?vue&type=template&id=7843418b&scoped=true"
import script from "./cardManagement.vue?vue&type=script&lang=js"
export * from "./cardManagement.vue?vue&type=script&lang=js"
import style0 from "./cardManagement.vue?vue&type=style&index=0&id=7843418b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7843418b",
  null
  
)

export default component.exports